export default "__VITE_ASSET__BES189I3__"